module.exports = __webpack_public_path__ + "media/src/admin/images/sec-4445c03558213075e980baa2dde9c7fc.svg";